var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"list"},_vm._l((_vm.skills),function(item,index){return _c('Badge',{key:index,attrs:{"text":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }